<script setup lang="ts">
import { formatCurrency } from "@lib/utils/formatCurrency";
import { Bike, Car, MoonIcon, CircleStar } from "lucide-vue-next";
import WalkingIcon from "@/ui-plus/icons/WalkingIcon.vue";
import type { ResType } from "@api-client/typeUtils";
import { type deliveryteamPlaceOrderApiClient } from '@api-client/place_order_deliveryteam';

type CourierType = NonNullable<
    ResType<typeof deliveryteamPlaceOrderApiClient.nearby_couriers.$post>["data"]["couriers"]
>[number];

const courierDriverIcons = {
    'WALKING': WalkingIcon,
    'BICYCLING': Bike,
    'DRIVING': Car,
} as const;

defineProps<{
    courier: CourierType;
}>();

</script>

<template>
    <div @click="$emit('openOfferDetails', courier)"
         class="border border-secondary bg-card rounded-lg p-1 flex items-center gap-3 cursor-pointer hover:bg-muted/50 overflow-hidden"
         :class="{ 'brightness-75': !courier.isOpen }">
        <div class="p-2">
            <component :is="courierDriverIcons[courier.mode ?? 'WALKING']"
                       class="h-12 w-12 shrink-0" />
        </div>
        <div v-if="courier?.breakdown"
             class="text-right font-bold text-lg shrink-0 border-l border-3 border-foreground pl-3 h-14 flex items-center">
            {{ formatCurrency(courier.breakdown.buyerPays, courier.taxSettings?.currency) }}
        </div>
        <div v-if="courier.distance"
             class="text-xs text-muted-foreground text-center min-w-20 max-w-20 border-l border-3 border-foreground pl-3 h-14">
            ~{{ courier.distance }}
            {{ courier.measure }}
            <br>
            away from pickup
        </div>
        <div v-if="!courier.isOpen"
             class="text-destructive">
            <MoonIcon class="h-5 w-5" />
        </div>
        <div v-if="courier.applyFeeTransform"
             class="text-primary"
             title="Special offer">
            <CircleStar class="h-10 w-10" />
        </div>
        <span class="truncate block max-w-[10rem]"
              :title="courier.deliveryteamName">
            {{ courier.deliveryteamName }}
        </span>


    </div>
</template>
